/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from "@reduxjs/toolkit";
import { getRevenueAction } from "../actions/adminDashboardAction";

const initialState: any = {};

const getRevenueSlice = createSlice({
  name: "Guest User Paid Reports",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRevenueAction.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getRevenueAction.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getRevenueAction.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default getRevenueSlice.reducer;
